export {
  Header,
  Wrapper,
  Section,
  Banner,
  Div,
  Container,
  Title,
  Subtitle,
  StyledBadge,
  StyledInputOtp,
  ButtonText,
  Span,
  ResendLink,
  SuccessMessage,
} from "../../modules/Auth/components/AuthPasswordLayout/AuthPassword.styles";

import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;

  &:focus {
    outline: none;
    border-color: #01ab7d;
  }
`;

export const ErrorMessage = styled.p`
  color: #e53935;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  margin: 0;
  text-align: center;
`;

export const LinkButton = styled.button.attrs({ type: "button" })`
  background: none;
  border: none;
  color: #01ab7d;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  padding: 0;

  &:hover {
    color: #007656;
  }
`;

export const LoadingStatusMessage = styled.p`
  color: #383839;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  margin: 0 0 8px;
  min-height: 40px;
  transition: opacity 0.25s ease;
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  background-color: #e7e8ec;
  border-radius: 999px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{
  $progress: number;
  $smooth: boolean;
}>`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background-color: #41c78f;
  border-radius: 999px;
  transition: ${({ $smooth }) =>
    $smooth ? "width 0.5s ease-out" : "width 0.1s linear"};
`;

export const ProgressLabel = styled.span`
  color: #838486;
  font-family: "Noto Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  text-align: right;
`;
